/**
 * A clock that follows the server's: `serverNow` is the server's time when the response was
 * built, so the offset to this device is fixed the moment the response arrives. Build one per
 * response (memoized on `serverNow`), never per render.
 */
export function clockFrom(serverNow: number): () => number {
  const offset = serverNow - Date.now()
  return () => Date.now() + offset
}
